import React, { useState, useEffect } from "react";
import NavNew from "../NavBar/NavNew";
import NavNewDark from "../NavBar/NavNewDark";
import Faq from "./../FAQ/Faq";
import Contact from "./../Contact/Contact";
import { useLocation } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import FooterNew from "../NavBar/FooterNew";
import { Col, Row, Button, Container } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "./../Carousel/Carousel";
import Parser from "html-react-parser";
import NewBannerImage from "../../assets/header-banner.jpg";
import Flight from "../../assets/split-1.jpg";
import Lodgings from "../../assets/split-2.jpg";
import Transit from "../../assets/split-3.jpg";
import Meals from "../../assets/split-4.jpg";
import TourGuides from "../../assets/split-5.jpg";
import logo1 from "../../assets/logo-1.png";
import logo2 from "../../assets/logo-2.png";
import logo3 from "../../assets/logo-3.png";
import logo4 from "../../assets/logo-4.png";
import arrowLeft from "../../assets/arrow-left.png";
import arrowRight from "../../assets/arrow-right.png";
import profile from "../../assets/testimonial-profile.jpg";
import comma from "../../assets/comma.png";
import tourBanner from "../../assets/tour-banner.jpg";
import bannerbackground from "../../assets/bannerbackground.jpg";
import Nav from "../NavBar/Nav";
toast.configure();

export default function HomeNew() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const [selectShow, setSelectedShow] = useState(3);

  const [bannerTitle, setBannerTittle] = useState("");
  const [bannerCaption, setBannerCaption] = useState("");
  const [bannerImage, setBannerImg] = useState("");

  const [slideData, setSlideData] = useState();
  const [testimonialData, setTestimonialData] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const { isClaimed = 0, unique_no = null, message = "" } = location.state || {};
  console.log("Navigation State101:", { isClaimed, unique_no, message });
  useEffect(() => {
    getData();
    getSliderData();
    getTestimonialData();
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 1200 && window.innerWidth > 770) {
      setSelectedShow(2);
    } else if (window.innerWidth <= 770) {
      setSelectedShow(1);
    } else {
      setSelectedShow(3);
    }
  }, []);
  useEffect(() => {
    window.onresize = function () {
      // //console.log(window.innerHeight);
      //console.log(window.innerWidth);
      if (window.innerWidth <= 1200 && window.innerWidth > 770) {
        setSelectedShow(2);
      } else if (window.innerWidth <= 770) {
        setSelectedShow(1);
      } else {
        setSelectedShow(3);
      }
    };
    // if(width <= 1000){
    //   setSelectedShow(2)
    // }
  }, [window.innerWidth]);

  const getData = () => {
    axios
      .get(
        // `${base_url.api1}/cmsapp/cms?id=21` //Live
        // // `${base_url.api1}/cmsapp/cms?id=42` //Test
        `${base_url.api1}/cmsapp/cms_list` //Test
      )
      .then(
        (response) => {
          //console.log(response.data.Cms);
          setBannerTittle(response.data.Cms.title);
          setBannerCaption(response.data.Cms.caption);
          setBannerImg(response.data.Cms.image);
        },
        (error) => {
          //console.log(JSON.stringify(error));
        }
      );
  };

  const getMessage = () => {
    // 1. If the API sent a specific message string, show that first
    if (message && message !== "") {
      return message;
    }
    // switch (isClaimed) {
    //   case 1:
    //     return "Your Claim has been submitted successfully.";
    //   case 2:
    //     return "Your booking request for the vehicle has been submitted successfully.";
    //   case 3:
    //     return "The inquiry has been received and payment done successfully we will contact you soon.";
    //   case 4:
    //     return "Your inquiry has been received but the payment process failed we will contact you soon.";
    //   default:
    //     return "Your Signature has been captured successfully. You can now submit the Claim Form.";
    // }
  };

  const getSliderData = () => {
    axios
      .get(
        `${base_url.api1}/cmsapp/cms?page_name=home&type=slide` //Test
      )
      .then(
        (response) => {
          //console.log("100", response.data.Cms.cms_slides);
          setSlideData(response.data.Cms.cms_slides);
        },
        (error) => {
          //console.log(JSON.stringify(error));
        }
      );
  };

  const getTestimonialData = () => {
    axios
      .get(
        `${base_url.api1}/cmsapp/cms?page_name=home&type=testimonial` //Test
      )
      .then(
        (response) => {
          //console.log("116", response.data.Cms);
          setTestimonialData(response.data.Cms.cms_slides);
        },
        (error) => {
          //console.log(JSON.stringify(error));
        }
      );
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  if (!slideData || slideData.length === 0) {
    return null; // If no data, you can return null or a placeholder
  }

  const currentSlideData = slideData[currentSlide];
  const titleWithLineBreaks = currentSlideData.title.replace(/\r\n/g, "<br>");
  const captionWithLineBreaks = currentSlideData.caption.replace(
    /\r\n/g,
    "<br>"
  );
  const imageUrl = `https://apilinsoatours.odisoft.in${currentSlideData.image}`;

  // ====================================== ***************************** ========================================

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonialData.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonialData.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Check if testimonialsData is defined and not empty
  if (!testimonialData || testimonialData.length === 0) {
    return <p></p>;
  }

  const currentTestimonial = testimonialData[currentIndex];
  const testimonial = `https://apilinsoatours.odisoft.in${currentTestimonial.image}`;

  return (
    <React.Fragment>
      <Nav />
      {/* */}
      <section
        className="section"
        id="testimonial"
        style={{ 
          padding: "100px 0",
          background: "linear-gradient(to bottom, #f9f9f9, #ffffff)",
          minHeight: "60vh",
          display: "flex",
          alignItems: "center"
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <div 
                style={{
                  backgroundColor: "#fff",
                  padding: "50px 30px",
                  borderRadius: "15px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  textAlign: "center"
                }}
              >
                {/* Success Icon */}
                <div style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#e6f4f1",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 30px"
                }}>
                  <span style={{ fontSize: "40px", color: "#005b67" }}>✓</span>
                </div>

                <h1 className="new_tour_head_2" style={{ 
                  color: "#005b67", 
                  fontSize: "2.8rem", 
                  marginBottom: "15px",
                  fontWeight: "700" 
                }}>
                  Thank You
                </h1>

                <h4
                  style={{
                    color: "#545267",
                    fontWeight: "400",
                    lineHeight: "1.6",
                    marginBottom: "30px",
                  }}
                >
                  {getMessage()}
                </h4>

                {unique_no && (
                  <div style={{
                    background: "#f8f9fa",
                    padding: "15px",
                    borderRadius: "8px",
                    display: "inline-block",
                    border: "1px dashed #ced4da"
                  }}>
                    <h5
                      style={{
                        color: "#545267",
                        fontWeight: "500",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      Your Profile ID : <strong style={{ color: "#005b67" }}>{unique_no}</strong>
                    </h5>
                  </div>
                )}
                
                <div style={{ marginTop: "40px" }}>
                   <Button 
                    onClick={() => window.location.href = "/"}
                    style={{ 
                      backgroundColor: "#005b67", 
                      border: "none", 
                      padding: "10px 30px",
                      borderRadius: "50px",
                      fontWeight: "600"
                    }}
                  >
                    Back to Home
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* */}

      <FooterNew />
    </React.Fragment>
  );
}